(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["night-quotes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('night-quotes')) {
  customElements.define('night-quotes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.night-quotes__track');
      this.toggle = this.querySelector('[data-toggle]');
      this.slides = [...this.querySelectorAll('.night-quotes__slide')];
      this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(window.Shopify?.designMode);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.setPaused(true);
        this.move(Number(button.dataset.direction));
      }, options));
      this.toggle.addEventListener('click', () => this.setPaused(!this.paused), options);
      this.track.addEventListener('pointerdown', () => this.setPaused(true), options);
      this.track.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.setPaused(true); this.move(e.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.move(1);
      }, Number(this.dataset.interval) || 7000);
      this.querySelector('.night-quotes__controls').hidden = this.slides.length < 2;
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.night-quotes__slide');
        const index = this.slides.indexOf(slide);
        if (index >= 0) { this.setPaused(true); this.track.scrollTo({left: index * this.track.clientWidth, behavior: 'instant'}); }
      }, options);
      this.setPaused(this.paused);
    }
    setPaused(value) {
      this.paused = value;
      this.toggle.textContent = value ? this.toggle.dataset.play : this.toggle.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(value));
    }
    move(direction) {
      const current = Math.round(this.track.scrollLeft / this.track.clientWidth);
      const next = (current + direction + this.slides.length) % this.slides.length;
      this.track.scrollTo({left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { clearInterval(this.timer); this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["night-signature-migrated"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('signature-mask-picker')) {
    customElements.define('signature-mask-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const buttons = Array.from(this.querySelectorAll('[data-target]'));
        const panels = Array.from(this.querySelectorAll('[data-panel]'));
        const choose = (button) => {
          panels.forEach((panel) => panel.hidden = panel.id !== button.dataset.target);
          buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        };
        if (buttons.length) {
          choose(buttons[0]);
          buttons.forEach((button) => button.addEventListener('click', () => choose(button)));
        }
        const formatMoney = (cents) => {
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(cents);
          }
          return '$' + (cents / 100).toFixed(2);
        };
        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-image]');
          if (thumb) {
            const panel = thumb.closest('[data-panel]');
            const mainImage = panel.querySelector('.signature-mask__main-image');
            if (mainImage) {
              mainImage.removeAttribute('srcset');
              mainImage.src = thumb.dataset.image;
              mainImage.alt = thumb.dataset.alt || mainImage.alt;
            }
          }
        });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-quantity-choice]')) {
            const form = event.target.closest('form');
            const quantityInput = form.querySelector('[data-quantity-input]');
            if (quantityInput) quantityInput.value = event.target.value;
          }
          if (!event.target.matches('[data-variant]')) return;
          const option = event.target.selectedOptions[0];
          const panel = event.target.closest('[data-panel]');
          const buy = panel.querySelector('[data-buy]');
          const available = option.dataset.available === 'true';
          const unitCents = Number(option.dataset.priceCents || 0);
          const discount = Number(panel.querySelector('[data-discount]')?.dataset.discount || 5);
          const compare = unitCents * 2;
          const duo = Math.round(compare * (100 - discount) / 100);
          buy.disabled = !available;
          buy.textContent = available ? buy.dataset.addLabel : buy.dataset.soldLabel;
          panel.querySelector('[data-price]').textContent = option.dataset.price;
          panel.querySelectorAll('[data-single-price]').forEach((item) => item.textContent = formatMoney(unitCents));
          panel.querySelectorAll('[data-duo-price]').forEach((item) => item.textContent = formatMoney(duo));
          panel.querySelectorAll('[data-duo-compare]').forEach((item) => item.textContent = formatMoney(compare));
          panel.querySelectorAll('[data-duo-save]').forEach((item) => item.textContent = formatMoney(compare - duo));
          panel.querySelectorAll('[data-duo-subtitle]').forEach((item) => {
            if (!item.dataset.customSubtitle) item.textContent = 'You save ' + discount + '%';
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["night-signature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('night-product-picker')) {
  customElements.define('night-product-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const controls = this.querySelector('[data-color-controls]');
      const buttons = Array.from(this.querySelectorAll('[data-panel-target]'));
      const panels = Array.from(this.querySelectorAll('[data-product-panel]'));
      const selectPanel = (button) => {
        panels.forEach(panel => { panel.hidden = panel.id !== button.dataset.panelTarget; });
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const active = panels.find(panel => panel.id === button.dataset.panelTarget);
        if (active) active.querySelector('.night-product-info').insertBefore(controls, active.querySelector('.night-copy'));
      };
      if (buttons.length) {
        controls.hidden = false;
        selectPanel(buttons[0]);
        buttons.forEach(button => button.addEventListener('click', () => selectPanel(button)));
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-product-panel]');
          const button = buttons.find(b => b.dataset.panelTarget === panel?.id);
          if (button) selectPanel(button);
        });
      }
      const setImage = (panel, url, alt) => {
        const img = panel.querySelector('.night-product-main');
        if (!img || !url) return;
        img.removeAttribute('srcset');
        img.src = url;
        if (alt) img.alt = alt;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-image-url]');
        if (button) setImage(button.closest('[data-product-panel]'), button.dataset.imageUrl, button.dataset.imageAlt);
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-purchase-option]')) {
          const panel = event.target.closest('[data-product-panel]');
          const price = panel.querySelector(event.target.value === '2' ? '[data-duo-price]' : '[data-single-price]');
          if (price) panel.querySelector('[data-price]').textContent = price.textContent;
          return;
        }
        if (!event.target.matches('[data-variant-select]')) return;
        const option = event.target.selectedOptions[0];
        const panel = event.target.closest('[data-product-panel]');
        const buy = panel.querySelector('[data-buy]');
        const available = option.dataset.available === 'true';
        buy.disabled = !available;
        buy.textContent = available ? buy.dataset.addLabel : buy.dataset.soldLabel;
        const single = panel.querySelector('[data-single-price]');
        const duo = panel.querySelector('[data-duo-price]');
        if (single) single.textContent = option.dataset.price;
        if (duo) duo.textContent = option.dataset.duoPrice;
        const quantity = panel.querySelector('[data-purchase-option]:checked')?.value || '1';
        panel.querySelector('[data-price]').textContent = quantity === '2' ? option.dataset.duoPrice : option.dataset.price;
        setImage(panel, option.dataset.image);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reverie-faq"] && !Shopify.designMode) return;
  try {
    
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('details');
    if (detail) detail.open = true;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reverie-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reverie-product-tabs')) {
    customElements.define('reverie-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const buttons = Array.from(this.querySelectorAll('[data-target]'));
        const panels = Array.from(this.querySelectorAll('[data-panel]'));
        const formatMoney = (cents) => window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
        const choose = (button) => {
          panels.forEach((panel) => panel.hidden = panel.id !== button.dataset.target);
          buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        };
        if (buttons.length) {
          choose(buttons[0]);
          buttons.forEach((button) => button.addEventListener('click', () => choose(button)));
          this.addEventListener('shopify:block:select', event => {
            const panel = event.target.closest('[data-panel]');
            const button = buttons.find(b => b.dataset.target === panel?.id);
            if (button) choose(button);
          });
        }
        this.addEventListener('click', (event) => {
          const tile = event.target.closest('[data-image]');
          if (!tile) return;
          const gallery = tile.closest('.reverie-product__gallery');
          const panel = tile.closest('[data-panel]');
          const tiles = Array.from(panel.querySelectorAll('.reverie-product__media[data-image]'));
          const isMobileGallery = window.matchMedia('(max-width: 989px)').matches;
          if (tile.classList.contains('reverie-product__media--main') || isMobileGallery) {
            this.openLightbox(panel, tiles.indexOf(tile));
            return;
          }
          const main = gallery.querySelector('.reverie-product__media--main img');
          const mainButton = gallery.querySelector('.reverie-product__media--main');
          if (main) {
            main.removeAttribute('srcset');
            main.src = tile.dataset.image;
            main.alt = tile.dataset.alt || main.alt;
          }
          if (mainButton) {
            mainButton.dataset.image = tile.dataset.image;
            mainButton.dataset.alt = tile.dataset.alt || mainButton.dataset.alt || '';
          }
        });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-quantity-choice]')) {
            const form = event.target.closest('form');
            const quantity = form.querySelector('[data-quantity-input]');
            if (quantity) quantity.value = event.target.value;
          }
          if (!event.target.matches('[data-variant]')) return;
          const option = event.target.selectedOptions[0];
          const panel = event.target.closest('[data-panel]');
          const unit = Number(option.dataset.priceCents || 0);
          const discount = Number(panel.querySelector('[data-discount]')?.dataset.discount || 5);
          const compare = unit * 2;
          const duo = Math.round(compare * (100 - discount) / 100);
          const buy = panel.querySelector('[data-buy]');
          const available = option.dataset.available === 'true';
          panel.querySelector('[data-price]').textContent = option.dataset.price;
          panel.querySelectorAll('[data-single-price]').forEach((item) => item.textContent = formatMoney(unit));
          panel.querySelectorAll('[data-duo-price]').forEach((item) => item.textContent = formatMoney(duo));
          panel.querySelectorAll('[data-duo-compare]').forEach((item) => item.textContent = formatMoney(compare));
          buy.disabled = !available;
          buy.textContent = available ? buy.dataset.addLabel : buy.dataset.soldLabel;
        });
      }

      openLightbox(panel, index) {
        const lightbox = panel.querySelector('[data-lightbox]');
        const image = panel.querySelector('[data-lightbox-image]');
        const count = panel.querySelector('[data-lightbox-count]');
        const tiles = Array.from(panel.querySelectorAll('.reverie-product__media[data-image]'));
        if (!lightbox || !image || !tiles.length) return;
        let activeIndex = Math.max(0, index);
        const render = () => {
          const tile = tiles[activeIndex];
          image.src = tile.dataset.image;
          image.alt = tile.dataset.alt || '';
          if (count) count.textContent = `${activeIndex + 1} / ${tiles.length}`;
        };
        const close = () => {
          lightbox.hidden = true;
          document.documentElement.classList.remove('reverie-product-lightbox-open');
          document.removeEventListener('keydown', onKeydown);
        };
        const move = (direction) => {
          activeIndex = (activeIndex + direction + tiles.length) % tiles.length;
          render();
        };
        const onKeydown = (event) => {
          if (event.key === 'Escape') close();
          if (event.key === 'ArrowLeft') move(-1);
          if (event.key === 'ArrowRight') move(1);
        };
        const closeButton = lightbox.querySelector('[data-lightbox-close]');
        const previousButton = lightbox.querySelector('[data-lightbox-prev]');
        const nextButton = lightbox.querySelector('[data-lightbox-next]');
        if (closeButton) closeButton.onclick = close;
        if (previousButton) previousButton.onclick = () => move(-1);
        if (nextButton) nextButton.onclick = () => move(1);
        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) close();
        }, { once: true });
        let touchStart = 0;
        image.ontouchstart = (event) => {
          touchStart = event.changedTouches[0].clientX;
        };
        image.ontouchend = (event) => {
          const distance = event.changedTouches[0].clientX - touchStart;
          if (Math.abs(distance) > 42) move(distance > 0 ? -1 : 1);
        };
        render();
        lightbox.hidden = false;
        document.documentElement.classList.add('reverie-product-lightbox-open');
        document.addEventListener('keydown', onKeydown);
        closeButton?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silk-help"] && !Shopify.designMode) return;
  try {
    
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('details');
    if (detail) detail.open = true;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silk-sleep-ritual-carousel"] && !Shopify.designMode) return;
  try {
    
  const updateSilkRitualProgress = (root) => {
    const track = root.querySelector('.silk-ritual-carousel__track');
    const bar = root.querySelector('.silk-ritual-carousel__progress-bar');

    if (!track || !bar) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 0) {
      bar.style.width = '100%';
      return;
    }

    const slideCount = Math.max(1, track.children.length);
    const base = 100 / slideCount;
    const progress = base + (track.scrollLeft / maxScroll) * (100 - base);
    bar.style.width = `${Math.min(100, Math.max(base, progress))}%`;
  };

  const initSilkRitualCarousels = () => {
    document.querySelectorAll('.silk-ritual-carousel').forEach((root) => {
      const track = root.querySelector('.silk-ritual-carousel__track');
      if (!track || track.dataset.silkRitualReady === 'true') return;

      track.dataset.silkRitualReady = 'true';
      updateSilkRitualProgress(root);

      track.addEventListener('scroll', () => updateSilkRitualProgress(root), { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      });

      window.addEventListener('resize', () => updateSilkRitualProgress(root));
    });
  };

  initSilkRitualCarousels();
  document.addEventListener('shopify:section:load', initSilkRitualCarousels);

  } catch(e) { console.error(e); }
})();
})();
